import { createPortal } from "react-dom";
import React, { useRef, useState, useEffect, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
// import "./landing.scss";
import Rate from "rc-rate";
import "rc-rate/assets/index.css";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { BiMinus, BiTrash } from "react-icons/bi";
import { BsPlus } from "react-icons/bs";
import { connection } from "../../utils/apiConnection.ts";
import EditSpecialBasketModal from "./EditSpecialBasketModal.jsx";
import Formatter from "hoc/Formatter";
import Comments from "../supplier/Comments";

import sabadLog from "../../assets/images/logo-sabadi.png";
import CartItemsContext from "context/ShoppingCartItems";
import Loader from "utils/Loader";
import { TbBasket } from "react-icons/tb";
export default function SpecialBasketModal({
  selectedBasket,
  setUpdater,
  updater,
}) {
  const deletHandler = () => {
    connection("/supplier/delete_basket", {
      basket_id: selectedBasket.basket_supplier.ready_to_order_basket__id,
    }).then((data) => {
      console.log("data2:", data);
      if (data.status.status == 1) {
        setUpdater(!updater);
        toast.success("محصول با موفقیت حذف شد.");
        document.querySelector("#sabadModal .btn-close").click();
      } else {
        toast.error("خطا در حذف محصول");
      }
      // if (data.status == 1) {
      //   setUpdater((prev) => {
      //     return !prev;
      //   });
      //   toast.success("اطلاعات سبد با موفقیت حذف شد.");
      //   document.querySelector("#btn-del-basket").disabled = false;
      //   document.querySelector("#sabadModal.btn-close").click();
      //   navigate("/", { replace: true });
      // } else {
      //   Swal.fire("مشکلی در حذف سبد پیش آمده است.");
      // }
    });
  };
  const {
    shoppingData,
    updateShoppingList,
    currentInventory,
    prices,
    setPrices,
    itemsCount,
    itemsId,
    getCount,
    isLoading,
    setIsLoading,
  } = useContext(CartItemsContext);
  const { isLogged, userInfo } = useContext(AuthenticationContext);
  const [commentUpdater, setCommentUpdater] = useState(true);
  const navigate = useNavigate();
  const [sendComment, setSendComment] = useState({
    rating: "",
    txt: "",
    product_id: "",
  });
  const [comments, setComments] = useState([]);
  const [amount, setAmount] = useState("");
  const deleteBasket = () => {
    Swal.fire({
      title: "آیا از حذف سبد اطمینان دارید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف",
    }).then((result) => {
      if (result.isConfirmed) {
        deletHandler();
      } else if (result.isDenied) {
        Swal.fire("حذف سبد لغو شد", "", "info");
      }
    });
  };
  const addCartItem = (type, id, count, price, max, currentCount) => {
    setIsLoading(true);
    let temp = { count: count };
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id, price: price };
    }
    if (type == "basket" && currentCount == max) {
      toast.error(`حداکثر تعداد سفارش این سبد ${max} می باشد.`);
    } else {
      connection("api/addcartitem", temp).then((data) => {
        if (data.status == 1) {
          toast.success("سبد با موفقیت به سبد خرید شما اضافه شد.");
          updateShoppingList();
        } else {
          toast.error("در حال حاضر امکان افزودن سبد وجود ندارد.");
          setIsLoading(false);
        }
      });
    }
  };
  const reduceCartItem = (type, id) => {
    setIsLoading(true);
    let temp = {};
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id };
    }
    connection("api/reducecartitems", temp).then((data) => {
      if (data.status == 1) {
        toast.success("سبد با موفقیت از سبد خرید شما کم شد.");
        updateShoppingList();
        // setIsLoading(false);
      } else {
        toast.error("در حال حاضر امکان کم کردن سبد وجود ندارد.");
        setIsLoading(false);
      }
    });
  };
  const addCart = () => {
    if (amount != "") {
      connection("api/addcartitem", {
        basketId: selectedBasket.basket_supplier.ready_to_order_basket__id,
        count: amount,
      }).then((data) => {
        if (data.status == 1) {
          toast.success("به لیست خرید اضافه شد");
          updateShoppingList();
          setAmount("");
          document.querySelector("#sabadModal .btn-close").click();
        } else {
          toast.error("مشکلی در افزودن سبد به سبد خریدتان به وجود آمده!");
        }
      });
    } else {
      toast.error("لطفا تعداد را وارد کنید");
    }
  };
  // rating
  const changeHandler = (value, type) => {
    setSendComment((prev) => {
      return { ...prev, [type]: value };
    });
    // console.log("send comment : ", sendComment);
  };
  useEffect(() => {
    connection("api/get_comments", {
      rto_basket_id: selectedBasket.basket_supplier
        ? selectedBasket.basket_supplier.ready_to_order_basket__id
        : "",
    }).then((data) => {
      setComments(data.data);
    });
  }, [selectedBasket]);
  const insertComment = () => {
    if (isLogged) {
      if (sendComment.txt != "") {
        connection("api/Insert_comments", {
          rto_basket_id:
            selectedBasket.basket_supplier.ready_to_order_basket__id,
          supplier_id: selectedBasket.basket_supplier.supplier_id,
          muid: userInfo.id,
          comment_txt: sendComment.txt,
          apfo_rate: sendComment.rating,
          // product_rate: sendComment.rating,
          mtm: Date.now().toString().slice(0, -3),
        }).then((data) => {
          if (data.status == 1) {
            toast.success("نظرتان با موفقیت ثبت شد");
            setSendComment({
              rating: "",
              txt: "",
              // product_id: ""
            });
            setCommentUpdater((prev) => {
              return !prev;
            });
          }
        });
      } else {
        toast.error("نظرتان را در مورد کالا بنویسید");
      }
    } else {
      toast.error("ابتدا وارد حساب کاربری خود شوید!");
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="sabadModal"
        tabIndex={-1}
        aria-labelledby="sabadModalLabel"
        aria-hidden="true"
        // style={{ zIndex: "1060" }}
      >
        <div className="modal-dialog " style={{ maxWidth: "900px" }}>
          <div className="modal-content">
            {isLoading && <Loader />}
            <div className="modal-body">
              <div className="d-flex justify-content-between mx-4 mt-3">
                <h5>
                  {selectedBasket.basket_supplier == undefined
                    ? ""
                    : selectedBasket.basket_supplier.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              {selectedBasket.basket_supplier && (
                <div>
                  {selectedBasket.basket_supplier.supplier_info && (
                    <div className="d-flex align-items-center mx-3">
                      {/* <div className="rounded-pill bg-light p-3 "> */}
                      {selectedBasket.basket_supplier.supplier_info.path ? (
                        <img
                          src={`http://sabadi.tatdemo.ir/${selectedBasket.basket_supplier.supplier_info.path}`}
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "25px",
                          }}
                        />
                      ) : (
                        <img
                          src={sabadLog}
                          style={{ width: "50px", height: "50px" }}
                        />
                      )}

                      {/* </div> */}
                      <div className="d-flex mx-2">
                        <h6 className="fs-14">نام فروشگاه : </h6>
                        <h6 className="fs-14 mx-1">
                          {selectedBasket.basket_supplier.supplier_info.title}
                        </h6>
                      </div>
                    </div>
                  )}
                  {/* <div className="d-flex mt-3 mx-3 basket-price"> */}
                  <div className="d-flex mt-3 mx-2 basket-price">
                    <h6>قیمت سبد : </h6>
                    <span className="fs-12 text-danger text-decoration-line-through mx-2">
                      {addCommas(selectedBasket.basket_supplier.total_price)}{" "}
                    </span>
                    <span className="fs-14 text-success fw-bold">
                      {addCommas(
                        +selectedBasket.basket_supplier.total_price -
                          +selectedBasket.basket_supplier.total_discount
                      )}{" "}
                      تومان
                    </span>
                  </div>
                </div>
                // </div>
              )}
              <div>
                {selectedBasket?.basket_supplier?.supplier_id &&
                  // selectedBasket.length > 0 &&
                  isLogged &&
                  userInfo.supplier_list.includes(
                    selectedBasket.basket_supplier.supplier_id.toString()
                  ) && (
                    <div>
                      <button
                        className="btn btn-primary"
                        // key={`special-basket${index}`}
                        // data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                        data-bs-target="#editSpecialBasketModal"
                      >
                        ویرایش
                      </button>
                      <button
                        id="btn-del-basket"
                        className="btn btn-danger mx-3"
                        onClick={deleteBasket}
                      >
                        حذف سبد
                      </button>
                    </div>
                  )}

                {/* <EditSpecialBasketModal
                  selectedBasket={selectedBasket}
                ></EditSpecialBasketModal> */}
              </div>
              <div className="d-flex  align-items-center mx-3 justify-content-end flex-wrap">
                {selectedBasket.basket_supplier &&
                getCount(
                  selectedBasket.basket_supplier.ready_to_order_basket__id,
                  "basket"
                ) == "0" ? (
                  <button
                    className={` btn text-light cartBtn shadow rounded  d-flex justify-content-center align-items-center`}
                    // onClick={onInc}
                    onClick={() => {
                      addCartItem(
                        "basket",
                        selectedBasket.basket_supplier
                          .ready_to_order_basket__id,
                        1,
                        selectedBasket.max_avb_in_order,
                        getCount(
                          "basket",
                          selectedBasket.basket_supplier
                            .ready_to_order_basket__id
                        )
                      );
                    }}
                  >
                    <TbBasket
                      color="red"
                      style={{ fontSize: "25px" }}
                      className="icon"
                    />
                    <span className=" ms-1" style={{ color: "red" }}>
                      افزودن به سبد خرید
                    </span>
                  </button>
                ) : (
                  <>
                    <button
                      className={` btn text-light cartBtn shadow rounded  d-flex justify-content-center align-items-center`}
                      // onClick={onInc}
                      onClick={() => {
                        addCartItem(
                          "basket",
                          selectedBasket.basket_supplier
                            .ready_to_order_basket__id,
                          1,
                          selectedBasket.max_avb_in_order,
                          getCount(
                            "basket",
                            selectedBasket.basket_supplier
                              .ready_to_order_basket__id
                          )
                        );
                      }}
                    >
                      <BsPlus
                        color="red"
                        style={{ fontSize: "25px" }}
                        className="icon"
                      />
                    </button>

                    <span className="mx-1">
                      {selectedBasket.basket_supplier &&
                        getCount(
                          selectedBasket.basket_supplier
                            .ready_to_order_basket__id,
                          "basket"
                        )}
                    </span>
                    <button
                      className="btn shadow rounded cartBtn d-flex justify-content-center align-items-center"
                      // onClick={onDecrease}
                      onClick={() => {
                        reduceCartItem(
                          "basket",
                          selectedBasket.basket_supplier
                            .ready_to_order_basket__id
                        );
                      }}
                    >
                      {selectedBasket.basket_supplier &&
                      getCount(
                        selectedBasket.basket_supplier
                          .ready_to_order_basket__id,
                        "basket"
                      ) == "1" ? (
                        <BiTrash
                          color="red"
                          className="icon"
                          style={{ fontSize: "20px" }}
                        />
                      ) : (
                        <BiMinus
                          color="red"
                          className="icon"
                          style={{ fontSize: "20px" }}
                        />
                      )}
                    </button>
                  </>
                )}
                {/* <div className="d-flex align-items-center mt-3">
                  <label className="mx-3">تعداد : </label>
                  <input
                    type="text"
                    className="form-control"
                    value={amount}
                    style={{ width: "75px" }}
                    onChange={(e) => {
                      if (isNaN(e.target.value)) {
                        toast.error("عدد را به درستی وارد کنید");
                      } else {
                        if (
                          selectedBasket.basket_supplier.max_avb_in_order == 0
                        ) {
                          setAmount(e.target.value);
                        } else {
                          +e.target.value <=
                          +selectedBasket.basket_supplier.max_avb_in_order
                            ? setAmount(e.target.value)
                            : toast.error(
                                `امکان سفارش سبد بیشتر از تعداد ${selectedBasket.basket_supplier.max_avb_in_order}  وجود ندارد`
                              );
                        }
                      }
                    }}
                  />
                </div> */}
                {/* <button
                  type="button"
                  className="text-white btn  p-3 mt-3 btn-addbasket"
                  style={{ backgroundColor: "#EF394E", borderRadius: "10px" }}
                  onClick={addCart}
                >
                  افزودن سبد به سبد خرید من
                </button> */}
              </div>
              {selectedBasket.basket_items == undefined
                ? ""
                : selectedBasket.basket_items.map((value) => {
                    return (
                      <div
                        className="d-flex flex-wrap mt-5 py-3"
                        style={{
                          borderBottom: "3px solid #CFCCDA",
                          borderTop: "3px solid #CFCCDA",
                        }}
                      >
                        <div className="w-25">
                          <Swiper
                            navigation={true}
                            modules={[Navigation]}
                            className="mySwiper"
                          >
                            {/* {value.images.map(value1 => {
                              return ( */}
                            <SwiperSlide>
                              <img
                                src={`http://sabadi.tatdemo.ir/${value.path}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  borderRadius: "10px",
                                }}
                              />
                            </SwiperSlide>
                            {/* ); })} */}
                          </Swiper>
                        </div>
                        <div className="w-75">
                          <div className=" d-flex flex-row flex-wrap mt-3 mx-2">
                            <div className="item flex-grow-1">
                              <div className="inner-item1 text-center fw-bold px-2 py-3 ">
                                عنوان{" "}
                              </div>
                              <div className="inner-item text-center px-2 py-3">
                                {value.product_title}
                              </div>
                            </div>
                            {value.product_description && (
                              <div className="item flex-grow-1">
                                <div className="inner-item1 text-center fw-bold px-2 py-3 ">
                                  توضیحات
                                </div>
                                <div className="inner-item text-center text-wrap px-2 py-3">
                                  {value.product_description}
                                </div>
                              </div>
                            )}

                            <div className="item flex-grow-1">
                              <div className="inner-item1 text-center fw-bold px-2 py-3 ">
                                تعداد
                              </div>
                              <div className="inner-item text-center px-2 py-3">
                                {addCommas(value.count)}
                              </div>
                            </div>
                            <div className="item flex-grow-1">
                              <div className="inner-item1 text-center fw-bold px-2 py-3 ">
                                قیمت واحد
                              </div>
                              <div className="inner-item text-center px-2 py-3">
                                {addCommas(value.price)} تومان
                              </div>
                            </div>

                            <div className="item flex-grow-1">
                              <div className="inner-item1 text-center fw-bold px-2 py-3 ">
                                قیمت کل
                              </div>
                              <div className="inner-item text-center px-2 py-3 ">
                                {/* {+value.basket_items.price *
                              value.basket_items.count} */}
                                {addCommas(+value.price * value.count)}
                                تومان
                              </div>
                            </div>
                          </div>
                          {/* {value.basket_items.available_order_option_ids.length > */}
                          {/* 0 && ( */}
                          {/* {value.available_order_option_ids.length > 0 &&
                            value.available_order_option_ids.map(value1 => {
                              return (
                                <div className="d-flex mt-3">
                                  <div class="form-check mx-3">
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="flexCheckDefault"
                                      checked
                                    />
                                    <label
                                      class="form-check-label"
                                      for="flexCheckDefault"
                                    >
                                      {/* {value1.title} */}
                          {/* </label>
                                  </div>
                                </div>
                              );
                              // );
                            })} */}{" "}
                          {/* */}
                        </div>
                      </div>
                    );
                  })}

              {/* </div> */}

              {/* <div className="mx-3 mt-5 shadow rounded-10 p-4">
                <div className="d-flex justify-content-between align-items-center send-comment">
                  <h6 className="fs-14 ">
                    لطفا نظر و دیدگاه خود را نسبت به کالای موردنظر بنویسید
                  </h6>
                  <div className="">
                   
                    <Rate
                      direction="rtl"
                      style={{ fontSize: "30px" }}
                      defaultValue={3}
                      // allowHalf={true}
                      value={sendComment.rating}
                      onChange={e => {
                        changeHandler(e, "rating");
                      }}
                    ></Rate>
                  </div>
                </div>
                <textarea
                  className="form-control"
                  style={{ height: "100px" }}
                  value={sendComment.txt}
                  onChange={e => {
                    changeHandler(e.target.value, "txt");
                  }}
                ></textarea>
                <div className="text-end mx-3 mt-3">
                  <button
                    className="btn btn-success px-3"
                    onClick={insertComment}
                  >
                    {" "}
                    ثبت نظر
                  </button>
                </div>
              </div> */}
              {comments && (
                <Formatter color={"#1C2140"} header={"نظرات کاربران"}>
                  <Comments
                    selectedBasket={selectedBasket}
                    commentUpdater={commentUpdater}
                    setCommentUpdater={setCommentUpdater}
                    // isProduct={false}
                  />
                </Formatter>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
